import React, { useState } from 'react';
import GlobalImage from '../../components/imgComponent/index'
import PageFooter from '../../components/page-footer';
import PageHeader from '../../components/page-header';
import PageTools from '../../components/page-tools';
import './index.less';

function Home() {

  const [curActiveKey, setCurActiveKey] = useState(0);
  const onMouseEnterHandle = (key) => () => {
    setCurActiveKey(key);
  };
  const onMouseLeaveHandle = (key) => () => {};

  return (
    <div className="home">
      <PageHeader />
      <div className="page flex-col">
        <div className="box_1 flex-col">
          
          <div className="box_6">
            <div  className="con-wrap">
              <div className="content">
                <div className="top-text">
                  <GlobalImage src="teach-title.png" alt="title" className="teach-title" />
                  <h3>构建数字化教学场景，提升教学效率</h3>
                  <div className="text">教育信息化是国家信息化的重要组成部分，对于转变教育思想和观<br/>念，深化教育改革，提高教育质量和效益，培养创新人才具有深远<br/>意义，是实现教育跨越式发展的必然选择。</div>
                </div>
                <GlobalImage src="top-pic.png" alt="pic" className="top-pic" />
              </div>
            </div>
          </div>
          <div className="box_7 flex-row">
            <GlobalImage className="image_4" src="title-bg-2x.png" alt="图片" />
            <div className="box_8 flex-col" />
            <span className="text_40">Enrich&nbsp;Learning&nbsp;&nbsp;Empower&nbsp;Teaching</span>
          </div>
          <div className="box_11 flex-row">
            <div className="image-wrapper_2 flex-col">
              <GlobalImage className="image_5" src="case1-2x.png" alt="图片" />
            </div>
            <div className="text-wrapper_4 flex-col justify-between">
              <span className="text_11">智慧教学解决方案</span>
              <span className="text_12">
                提供教、学、评、研一体化混合教学解决方案，通过生动优质的学习内容、高效便捷的教学工具、无缝对接的多终端支持，全方位提升学习体验和教学效果。采用基于数据的设计，应用数据科学和机器学习技术，建立学习模型，持续不断地分析教学活动和内容数据，为学习者提供个性化学习路径，为教师提供基于数据的学情预测和教学干预建议，实现智慧教学，智慧学习。
              </span>
            </div>
          </div>
          {/* <div className="box_14 flex-col"></div> */}
          {/* <div className="box_14 flex-col">
            <div className="section_4 flex-row justify-between">
              <div className="text-wrapper_5 flex-col justify-between">
                <span className="text_14">智慧测评解决方案</span>
                <span className="text_15">
                  专注为高校外语教学提供在线测评资源与服务的一站式测试解决方案。基于云服务的基础架构和大数据分析的核心理念，支持电脑、手机多终端考试，支持听、说、读、写、译全题型的智能评分，通过高质量题库、个性化题库管理系统以及覆盖测评全流程的在线考试管理系统，为院系建立多维度评价体系、开展数字化教学评估提供专业的解决方案，为高校创新教学模式、开展课题研究、增进合作交流提供强有力的支持与保障。
                </span>
              </div>
              <div className="image-wrapper_3 flex-col">
                <GlobalImage className="image_6" src="case2-2x.png" alt="图片" />
              </div>
            </div>
          </div> */}
          <div className='bg-245-247-250-1'>
          <div className="box_15 flex-row">
            <GlobalImage className="image_4" src="title-bg-2x.png" alt="图片" />
            <div className="section_5 flex-col" />
            <span className="text_41">核心产品</span>
          </div>
          <div className="box_16 flex-between">
            <div key={0} className={curActiveKey === 0 ? 'wrap_6 flex-row show' : 'wrap_6 flex-row"'} onMouseEnter={onMouseEnterHandle(0)} onMouseLeave={onMouseLeaveHandle(0)}>
              <div className="section_6 flex-col">
                <GlobalImage className="image_8" src="product-2x.png" alt="图片" />
                <span className="paragraph_1">
                  智慧
                  <br />
                  教学
                </span>
                <div className="image-wrapper_4 flex-col">
                  <GlobalImage className="image_9" src="p-bg-s-2x.png" alt="图片" />
                </div>
              </div>
              <div className="section_12 flex-col">
                <GlobalImage className="label_5" src="product-s-2x.png" alt="图片" />
                <span className="text_16">智慧教学</span>
                <span className="text_17">
                通过大数据挖掘和教学流程监控，为院校提供学生学习和教师教学数据、管理学习结果，汇聚分析形成性评价和终结性评价数据，反映教学整体状态，推动教学改革，形成混合式教学、翻转课堂，构建线上线下相结合的教学新模式，助力信息化教学真正成为教师教学活动的常态。
                </span>
                <div className="image-wrapper_10 flex-col">
                  <GlobalImage className="image_19" src="p-bg-2x.png" alt="图片" />
                </div>
              </div>
            </div>
            {/* <div key={1} className={curActiveKey === 1 ? 'wrap_6 flex-row show' : 'wrap_6 flex-row"'} onMouseEnter={onMouseEnterHandle(1)} onMouseLeave={onMouseLeaveHandle(1)}>
              <div className="section_6 flex-col">
                <GlobalImage className="image_8" src="product1-2x.png" alt="图片" />
                <span className="paragraph_1">
                  智慧
                  <br />
                  考试
                </span>
                <div className="image-wrapper_4 flex-col">
                  <GlobalImage className="image_9" src="p-bg-s1-2x.png" alt="图片" />
                </div>
              </div>
              <div className="section_12 flex-col">
                <GlobalImage className="label_5" src={productS1} alt="图片" />
                <span className="text_16">智慧考试</span>
                <span className="text_17">
                专业外语教学在线测评产品，实现考试全流程信息化，支持听、说、读、写、译多种题型的智能评阅，满足院校对大规模、高利害的分级考试、期中考试、期末考试、竞赛考试的差异化需求，配合智能防作弊措施，为高校外语考试管理与教学评估提供权威数据支撑，实现以评促教、以评促学。
                </span>
                <div className="image-wrapper_10 flex-col">
                  <GlobalImage className="image_19" src={pBg1} alt="图片" />
                </div>
              </div>
            </div> */}
            <div key={2} className={curActiveKey === 2 ? 'wrap_6 flex-row show' : 'wrap_6 flex-row"'} onMouseEnter={onMouseEnterHandle(2)} onMouseLeave={onMouseLeaveHandle(2)}>
              <div className="section_6 flex-col">
                <GlobalImage className="image_8" src="product2-2x.png" alt="图片" />
                <span className="paragraph_1">
                  智慧
                  <br />
                  作业
                </span>
                <div className="image-wrapper_4 flex-col">
                  <GlobalImage className="image_9" src="p-bg-s2-2x.png" alt="图片" />
                </div>
              </div>
              <div className="section_12 flex-col">
                <GlobalImage className="label_5" src="product-s2-2x.png" alt="图片" />
                <span className="text_16">智慧作业</span>
                <span className="text_17">
                支持数十种与语言教学相匹配的作业题型，能够覆盖课前、课中及课后多类场景的练习需求，支持主观题智能机评，提升作业批改效率。支持一键分享推荐作业，增强生生互动。
                </span>
                <div className="image-wrapper_10 flex-col">
                  <GlobalImage className="image_19" src="p-bg2-2x.png" alt="图片" />
                </div>
              </div>
            </div>
            <div key={3} className={curActiveKey === 3 ? 'wrap_6 flex-row show' : 'wrap_6 flex-row"'} onMouseEnter={onMouseEnterHandle(3)} onMouseLeave={onMouseLeaveHandle(3)}>
              <div className="section_6 flex-col">
                <GlobalImage className="image_8" src="product3-2x.png" alt="图片" />
                <span className="paragraph_1">
                  智慧
                  <br />
                  学习
                </span>
                <div className="image-wrapper_4 flex-col">
                  <GlobalImage className="image_9" src="p-bg-s3-2x.png" alt="图片" />
                </div>
              </div>
              <div className="section_12 flex-col">
                <GlobalImage className="label_5" src="product-s3-2x.png" alt="图片" />
                <span className="text_16">智慧学习</span>
                <span className="text_17">
                丰富多元的课程体系兼顾共性教育与个性教育，涵盖通用类课程、语言技能、文化素养、求职就业等多方面的拓展课程，全方位满足个性化学习需求，为积极引导学生自我管理、主动学习，激发求知欲望，提高学习效率保驾护航。
                </span>
                <div className="image-wrapper_10 flex-col">
                  <GlobalImage className="image_19" src="p-bg3-2x.png" alt="图片" />
                </div>
              </div>
            </div>
            <div key={4} className={curActiveKey === 4 ? 'wrap_6 flex-row show' : 'wrap_6 flex-row"'} onMouseEnter={onMouseEnterHandle(4)} onMouseLeave={onMouseLeaveHandle(4)}>
              <div className="section_6 flex-col">
                <GlobalImage className="image_8" src="product4-2x.png" alt="图片" />
                <span className="paragraph_1">
                  成绩
                  <br />
                  统计
                </span>
                <div className="image-wrapper_4 flex-col">
                  <GlobalImage className="image_9" src="p-bg-s4-2x.png" alt="图片" />
                </div>
              </div>
              <div className="section_12 flex-col">
                <GlobalImage className="label_5" src="product-s4-2x.png" alt="图片" />
                <span className="text_16">成绩统计</span>
                <span className="text_17">
                可对不同班级设定个性化成绩考核标准，涵盖线上、线下教学全流程，从课程学习成绩、学习时长、作业等多个维度汇聚学生行为数据，从而生成更为合理的学生评价结果，帮助教师更加客观的全面评价学生的学习效果。
                </span>
                <div className="image-wrapper_10 flex-col">
                  <GlobalImage className="image_19" src="p-bg4-2x.png" alt="图片" />
                </div>
              </div>
            </div>
            <div key={5} className={curActiveKey === 5 ? 'wrap_6 flex-row show' : 'wrap_6 flex-row"'} onMouseEnter={onMouseEnterHandle(5)} onMouseLeave={onMouseLeaveHandle(5)}>
              <div className="section_6 flex-col">
                <GlobalImage className="image_8" src="product5-2x.png" alt="图片" />
                <span className="paragraph_1">
                  学情
                  <br />
                  分析
                </span>
                <div className="image-wrapper_4 flex-col">
                  <GlobalImage className="image_9" src="p-bg-s5-2x.png" alt="图片" />
                </div>
              </div>
              <div className="section_12 flex-col">
                <GlobalImage className="label_5" src="product-s5-2x.png" alt="图片" />
                <span className="text_16">学情分析</span>
                <span className="text_17">
                学情分析基于学生学习过程数据和学习结果数据，刻画学生特征，辅助教师和院校从学生、班级等多个维度更好地掌握学情。针对学生的学习特征进行监测，将学生的学习情况以可视化的方式呈现给教师、学生，从而更加准确、有效地监测、评估教学质量状况，真实反映学生需求、学习形态与偏好等特征，为提高学习绩效和教学质量提供参考。
                </span>
                <div className="image-wrapper_10 flex-col">
                  <GlobalImage className="image_19" src="p-bg5-2x.png" alt="图片" />
                </div>
              </div>
            </div>
            <div key={6} className={curActiveKey === 6 ? 'wrap_6 flex-row show' : 'wrap_6 flex-row"'} onMouseEnter={onMouseEnterHandle(6)} onMouseLeave={onMouseLeaveHandle(6)}>
              <div className="section_6 flex-col">
                <GlobalImage className="image_8" src="product6-2x.png" alt="图片" />
                <span className="paragraph_1 overflow-fix">
                  智能
                  <br />
                  评阅引擎
                </span>
                <div className="image-wrapper_4 flex-col">
                  <GlobalImage className="image_9" src="p-bg-s6-2x.png" alt="图片" />
                </div>
              </div>
              <div className="section_12 flex-col">
                <GlobalImage className="label_5" src="product-s6-2x.png" alt="图片" />
                <span className="text_16">智能评阅引擎</span>
                <span className="text_17">
                智能评阅引擎是Unipus技术核心之一，多年来已于线上平稳服务全国逾两千万用户。引擎集成了神经机器翻译、BERT、迁移学习等深度学习领域的最新成果，在自动评分和语法纠错两大任务上，关键评测指标处于国内同行产品中的先进水平。
                </span>
                <div className="image-wrapper_10 flex-col">
                  <GlobalImage className="image_19" src="p-bg6-2x.png" alt="图片" />
                </div>
              </div>
            </div>
            <div key={7} className={curActiveKey === 7 ? 'wrap_6 flex-row show' : 'wrap_6 flex-row"'} onMouseEnter={onMouseEnterHandle(7)} onMouseLeave={onMouseLeaveHandle(7)}>
              <div className="section_6 flex-col">
                <GlobalImage className="image_8" src="product7-2x.png" alt="图片" />
                <span className="paragraph_1 overflow-fix1">
                  CLIO语音
                  <br />
                  评测引擎
                </span>
                <div className="image-wrapper_4 flex-col">
                  <GlobalImage className="image_9" src="p-bg-s7-2x.png" alt="图片" />
                </div>
              </div>
              <div className="section_12 flex-col">
                <GlobalImage className="label_5" src="product-s7-2x.png" alt="图片" />
                <span className="text_16">CLIO语音评测引擎</span>
                <span className="text_17">
                  CLIO语音评测引擎是基于外研社优质的口语练习和考试语料、以语言学专家团队拟定的评分标准为依据，完全自主研发的发音打分引擎。使用了先进的LSTM / End2End&nbsp;声学模型，采用并改进了业内主流的发音质量评价（GOP）算法，攻克了多读、漏读、错读、跳读等技术难点，支持英语发音准确度、流利度、总分等维度的评测打分，学年段覆盖儿童到成人。
                </span>
                <div className="image-wrapper_10 flex-col">
                  <GlobalImage className="image_19" src="p-bg7-2x.png" alt="图片" />
                </div>
              </div>
            </div>
          </div>

          </div>
          <div className="box_18 flex-col">
            <div className="box_19 flex-col">
              <div className="section_13 flex-row justify-between">
                <GlobalImage className="image_4" src="title-bg-2x.png" alt="图片" />
                <div className="group_2 flex-col" />
                <span className="text_28">安全稳定&nbsp;&nbsp;贴心服务</span>
              </div>
              <div className="section_14 flex-row justify-between">
                <div className="group_3 flex-col">
                  <div className="group_4 flex-col" />
                  <div className="group_5 flex-col">
                    <div className="section_15 flex-col">
                      <div className="image_22 s1" />
                      <span className="text_22">安全</span>
                      <span className="text_23">公安部安全等级保护三级认证</span>
                    </div>
                  </div>
                </div>
                <div className="group_3 flex-col">
                  <div className="group_4 flex-col" />
                  <div className="group_5 flex-col">
                    <div className="section_15 flex-col">
                      <div className="image_22 s2" />
                      <span className="text_22">稳定</span>
                      <span className="text_23">国家信息中心软件测评中心软件安全测试</span>
                    </div>
                  </div>
                </div>
                <div className="group_3 flex-col">
                  <div className="group_4 flex-col" />
                  <div className="group_5 flex-col">
                    <div className="section_15 flex-col">
                      <div className="image_22 s3" />
                      <span className="text_22">灵活</span>
                      <span className="text_23">高拓展性架构，快速打造个性教学系统</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="list_1 flex-row">
                <div className="list-items_1-0 flex-col">
                  <div className="box_25-0" />
                  <span className="text_24-0">顾问式服务</span>
                  <span className="text_25">根据院校需求定制个性化解决方案</span>
                </div>
                <div className="list-items_1-1 flex-col">
                  <div className="box_25-1 flex-col" />
                  <span className="text_24-0">7×24运维保障</span>
                  <span className="text_25">全天侯保障数据安全服务稳定</span>
                </div>
                <div className="list-items_1-2 flex-col">
                  <div className="box_25-2 flex-col" />
                  <span className="text_24-0">专属客服</span>
                <span className="text_25">在线客服快速响应解决客户问题</span>
                </div>
              </div>
              {/* <div className="text-wrapper_7 flex-row justify-between">
                <span className="text_25">根据院校需求定制个性化解决方案</span>
                <span className="text_26">全天侯保障数据安全服务稳定</span>
                <span className="text_27">在线客服快速响应解决客户问题</span>
              </div> */}
            </div>
          </div>
        </div>
        <PageTools />
      </div>
      <PageFooter />
    </div>
  );
}

export default Home;
